<template>
  <div class="pwd-page">
    <!-- Navigation -->
    <nav class="nav">
      <div class="nav-inner">
        <div class="nav-left">
          <el-image class="nav-logo" style="width: 40px;height: 40px;"
            :src="require('@/assets/img/qhy2.png')"></el-image>
          <span class="nav-name">{{ $siteConfig.siteName }}</span>
        </div>
        <div class="nav-right">
          <button class="btn-text" @click="$router.push('/')">首页</button>
          <button v-if="!isLogin" class="btn-primary" @click="$router.push('/login')">登录</button>
          <button v-else class="btn-text" @click="handleLogout">退出登录</button>
        </div>
      </div>
    </nav>

    <!-- Form Section -->
    <section class="pwd-section">
      <div class="pwd-bg">
        <div class="blob blob-1"></div>
        <div class="blob blob-2"></div>
      </div>
      <div class="pwd-content">
        <div class="pwd-card">
          <div class="pwd-header">
            <div class="pwd-badge">
              <app-icon  class="app-icon badge-icon" name="lock_reset"></app-icon>
              <span>账户安全</span>
            </div>
            <h1 class="pwd-title">{{ mode === 'change' ? '修改密码' : '找回密码' }}</h1>
            <p class="pwd-desc">{{ mode === 'change' ? '定期更换密码，保障账户安全' : '通过手机验证码重新设置密码' }}</p>
          </div>

          <!-- Mode Switch -->
          <div class="mode-switch">
            <button type="button" class="mode-btn" :class="{ active: mode === 'change' }"
              :disabled="!isLogin" @click="switchMode('change')">修改密码</button>
            <button type="button" class="mode-btn" :class="{ active: mode === 'forgot' }"
              @click="switchMode('forgot')">忘记密码</button>
          </div>

          <el-form :model="form" :rules="rules" ref="pwdForm" class="pwd-form" :key="mode">
            <!-- 修改密码（登录态） -->
            <template v-if="mode === 'change'">
              <div class="form-group">
                <label class="form-label">
                  <app-icon  class="app-icon label-icon" name="lock"></app-icon>
                  原密码
                </label>
                <el-form-item prop="oldps">
                  <el-input type="password" v-model="form.oldps" placeholder="请输入原密码（未设置过可留空）"
                    show-password></el-input>
                </el-form-item>
              </div>
            </template>

            <!-- 忘记密码（手机号 + 验证码） -->
            <template v-else>
              <div class="form-group">
                <label class="form-label">
                  <app-icon  class="app-icon label-icon" name="phone_iphone"></app-icon>
                  手机号
                </label>
                <el-form-item prop="phone">
                  <el-input v-model="form.phone" placeholder="请输入已注册手机号" maxlength="11"></el-input>
                </el-form-item>
              </div>

              <div class="form-group">
                <label class="form-label">
                  <app-icon  class="app-icon label-icon" name="sms"></app-icon>
                  验证码
                </label>
                <el-form-item prop="code">
                  <div class="code-row">
                    <el-input v-model="form.code" placeholder="请输入验证码" maxlength="4"></el-input>
                    <button type="button" class="btn-code" :disabled="codeLoading || countdown > 0"
                      @click="handleSendCode">
                      {{ countdown > 0 ? countdown + 's 后重发' : '获取验证码' }}
                    </button>
                  </div>
                </el-form-item>
              </div>
            </template>

            <div class="form-group">
              <label class="form-label">
                <app-icon  class="app-icon label-icon" name="password"></app-icon>
                新密码
              </label>
              <el-form-item prop="newps">
                <el-input type="password" v-model="form.newps" placeholder="请输入新密码（至少6位）"
                  show-password></el-input>
              </el-form-item>
            </div>

            <div class="form-group">
              <label class="form-label">
                <app-icon  class="app-icon label-icon" name="check_circle"></app-icon>
                确认新密码
              </label>
              <el-form-item prop="confirm">
                <el-input type="password" v-model="form.confirm" placeholder="请再次输入新密码" show-password
                  @keyup.native.enter="handleSubmit"></el-input>
              </el-form-item>
            </div>

            <el-form-item>
              <button type="button" class="btn-submit" @click="handleSubmit" :disabled="loading">
                <app-icon v-if="loading"  class="app-icon spinning" name="progress_activity"></app-icon>
                <span v-else>确认{{ mode === 'change' ? '修改' : '重置' }}</span>
              </button>
            </el-form-item>

            <div class="form-footer">
              <template v-if="mode === 'forgot'">
                <span>想起来了？</span>
                <el-link type="primary" @click="$router.push('/login')">返回登录</el-link>
              </template>
              <template v-else>
                <span>忘记了原密码？</span>
                <el-link type="primary" @click="switchMode('forgot')">通过手机号找回</el-link>
              </template>
            </div>
          </el-form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'User2Password',
  data() {
    const validateConfirm = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入新密码'))
      } else if (value !== this.form.newps) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    return {
      mode: 'forgot',
      loading: false,
      codeLoading: false,
      countdown: 0,
      countdownTimer: null,
      form: {
        phone: '',
        code: '',
        oldps: '',
        newps: '',
        confirm: ''
      },
      rules: {
        oldps: [],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { pattern: /^\d{4}$/, message: '验证码为4位数字', trigger: 'blur' }
        ],
        newps: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
        ],
        confirm: [
          { validator: validateConfirm, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    isLogin() {
      return !!window.localStorage.getItem('token')
    }
  },
  watch: {
    'form.newps'() {
      if (this.$refs.pwdForm && this.form.confirm) {
        this.$refs.pwdForm.validateField('confirm')
      }
    }
  },
  created() {
    const mode = this.$route.query.mode
    this.mode = mode === 'forgot' ? 'forgot' : (this.isLogin ? 'change' : 'forgot')
  },
  beforeDestroy() {
    if (this.countdownTimer) clearInterval(this.countdownTimer)
  },
  methods: {
    switchMode(mode) {
      if (mode === 'change' && !this.isLogin) {
        this.$msg.warning('请先登录后再修改密码')
        this.$router.push({ path: '/login', query: { redirect: '/password?mode=change' } })
        return
      }
      this.mode = mode
      this.form.code = ''
      this.form.oldps = ''
    },
    handleSendCode() {
      const phone = String(this.form.phone || '').trim()
      if (!/^1[3-9]\d{9}$/.test(phone)) {
        this.$msg.warning('请输入正确的手机号')
        return
      }
      const time = Math.round(Date.now() / 1000).toString()
      const t = (parseInt(phone.substring(0, 3), 10) + parseInt(phone.substring(7, 11), 10)) * 2 + parseInt(time, 10)
      this.codeLoading = true
      this.$ajax.post('api/v1/users/sms/send', {
        phone,
        t,
        time
      }).then(res => {
        if (res.data && res.data.status === 200) {
          this.$msg.success(res.data.msg || '验证码已发送')
          this.startCountdown()
        } else {
          this.$msg.error((res.data && (res.data.msg || res.data.detail)) || '发送失败')
        }
      }).catch(err => {
        const data = err.response && err.response.data
        this.$msg.error((data && (data.msg || data.detail)) || '发送失败，请稍后重试')
      }).finally(() => {
        this.codeLoading = false
      })
    },
    startCountdown() {
      this.countdown = 60
      if (this.countdownTimer) clearInterval(this.countdownTimer)
      this.countdownTimer = setInterval(() => {
        this.countdown -= 1
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer)
          this.countdownTimer = null
        }
      }, 1000)
    },
    handleSubmit() {
      this.$refs.pwdForm.validate(valid => {
        if (!valid) return
        const newps = this.form.newps
        if (this.mode === 'change') {
          this.submitChange(newps)
        } else {
          this.submitReset(newps)
        }
      })
    },
    submitChange(newps) {
      this.loading = true
      this.$ajax.post('api/v1/users/sms/change-password', {
        oldps: this.form.oldps,
        newps
      }).then(res => {
        if (res.data && res.data.status === 200) {
          this.$msg.success('密码修改成功，请重新登录')
          window.localStorage.removeItem('token')
          this.$router.push('/login')
        } else {
          this.$msg.error((res.data && (res.data.msg || res.data.detail)) || '修改失败')
        }
      }).catch(err => {
        const data = err.response && err.response.data
        this.$msg.error((data && (data.msg || data.detail)) || '修改失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    submitReset(newps) {
      this.loading = true
      this.$ajax.post('api/v1/users/sms/reset-password', {
        phone: String(this.form.phone).trim(),
        code: this.form.code,
        newps
      }).then(res => {
        if (res.data && res.data.status === 200) {
          this.$msg.success('密码重置成功，请使用新密码登录')
          this.$router.push('/login')
        } else {
          this.$msg.error((res.data && (res.data.msg || res.data.detail)) || '重置失败')
        }
      }).catch(err => {
        const data = err.response && err.response.data
        this.$msg.error((data && (data.msg || data.detail)) || '重置失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    handleLogout() {
      window.localStorage.removeItem('token')
      this.$msg.success('已退出登录')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
/* ===== Design Tokens ===== */
.pwd-page {
  --c-primary: #003ec7;
  --c-primary-container: #0052ff;
  --c-primary-fixed-dim: #b7c4ff;
  --c-white: #ffffff;
  --c-deep: #050a1f;
  --c-mid: #0a1128;
  --c-slate-300: #cbd5e1;
  --c-slate-400: #94a3b8;
  --font-heading: 'Hanken Grotesk', sans-serif;
  --font-body: 'Inter', sans-serif;
  --font-label: 'Geist', sans-serif;
  --space-xs: 4px;
  --space-base: 8px;
  --space-sm: 12px;
  --space-md: 24px;
  --space-lg: 48px;
  min-height: 100vh;
  background: var(--c-deep);
  color: var(--c-white);
  font-family: var(--font-body);
  -webkit-font-smoothing: antialiased;
}

/* ===== Navigation ===== */
.nav {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 50;
  background: rgba(2, 6, 23, 0.7);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.nav-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 var(--space-md);
  height: 64px;
}

.nav-left {
  display: flex;
  align-items: center;
  gap: var(--space-base);
}

.nav-logo {
  height: 40px;
  width: 40px;
  object-fit: contain;
}

.nav-name {
  font-family: var(--font-heading);
  font-size: 24px;
  font-weight: 700;
  color: var(--c-white);
}

.nav-right {
  display: flex;
  align-items: center;
  gap: var(--space-md);
}

.btn-text {
  background: none;
  border: none;
  color: var(--c-slate-300);
  font-family: var(--font-label);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.2s;
}

.btn-text:hover {
  color: var(--c-white);
}

.btn-primary {
  background: var(--c-primary-container);
  color: var(--c-white);
  border: none;
  padding: var(--space-sm) var(--space-lg);
  border-radius: 8px;
  font-family: var(--font-label);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-primary:hover {
  filter: brightness(1.1);
}

/* ===== Form Section ===== */
.pwd-section {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px var(--space-md) var(--space-lg);
  overflow: hidden;
}

.pwd-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
}

.blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  opacity: 0.5;
  animation: blobMove 25s infinite alternate ease-in-out;
}

.blob-1 {
  background: #001d3d;
  width: 600px;
  height: 600px;
  top: -100px;
  left: -100px;
}

.blob-2 {
  background: #003566;
  width: 500px;
  height: 500px;
  bottom: -50px;
  right: -50px;
  animation-delay: -10s;
}

@keyframes blobMove {
  0% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(5%, 10%) scale(1.1); }
  100% { transform: translate(-5%, 5%) scale(1); }
}

.pwd-content {
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 420px;
}

/* ===== Card ===== */
.pwd-card {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 40px 32px;
}

.pwd-header {
  text-align: center;
  margin-bottom: 24px;
}

.pwd-badge {
  display: inline-flex;
  align-items: center;
  gap: var(--space-xs);
  padding: 4px 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 9999px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin-bottom: 16px;
  font-family: var(--font-label);
  font-size: 12px;
  color: var(--c-slate-300);
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.badge-icon {
  font-size: 16px;
  color: var(--c-primary-fixed-dim);
}

.pwd-title {
  font-family: var(--font-heading);
  font-size: 28px;
  font-weight: 700;
  color: var(--c-white);
  margin: 0 0 8px 0;
}

.pwd-desc {
  font-size: 14px;
  color: var(--c-slate-400);
  margin: 0;
}

/* ===== Mode Switch ===== */
.mode-switch {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  padding: 4px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  margin-bottom: 24px;
}

.mode-btn {
  border: none;
  background: transparent;
  color: var(--c-slate-400);
  font-family: var(--font-label);
  font-size: 14px;
  font-weight: 500;
  padding: 9px 0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.25s;
}

.mode-btn.active {
  background: var(--c-primary-container);
  color: var(--c-white);
  box-shadow: 0 6px 16px -6px rgba(0, 82, 255, 0.5);
}

.mode-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* ===== Form Styles ===== */
.pwd-form {
  margin-top: 8px;
}

.form-group {
  margin-bottom: 18px;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: var(--font-label);
  font-size: 13px;
  font-weight: 500;
  color: var(--c-slate-300);
  margin-bottom: 8px;
  letter-spacing: 0.03em;
}

.label-icon {
  font-size: 16px;
  color: var(--c-primary-fixed-dim);
}

/* Element UI Input Override */
.pwd-form >>> .el-input__inner {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: var(--c-white);
  height: 44px;
  font-size: 14px;
  transition: all 0.2s;
}

.pwd-form >>> .el-input__inner::placeholder {
  color: var(--c-slate-400);
}

.pwd-form >>> .el-input__inner:focus {
  border-color: var(--c-primary-container);
  background: rgba(255, 255, 255, 0.12);
  box-shadow: 0 0 0 3px rgba(0, 82, 255, 0.2);
}

.pwd-form >>> .el-form-item__error {
  font-size: 12px;
  padding-top: 4px;
}

.code-row {
  display: flex;
  gap: 10px;
}

.code-row >>> .el-input {
  flex: 1;
}

.btn-code {
  flex-shrink: 0;
  min-width: 118px;
  height: 44px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  color: var(--c-white);
  font-family: var(--font-label);
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-code:hover:not(:disabled) {
  border-color: var(--c-primary-container);
  background: rgba(0, 82, 255, 0.2);
}

.btn-code:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* Submit Button */
.btn-submit {
  width: 100%;
  height: 48px;
  background: var(--c-primary-container);
  color: var(--c-white);
  border: none;
  border-radius: 10px;
  font-family: var(--font-heading);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-submit:hover {
  box-shadow: 0 20px 40px -12px rgba(0, 82, 255, 0.4);
  transform: translateY(-2px);
}

.btn-submit:active {
  transform: translateY(0);
}

.btn-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.form-footer {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  color: var(--c-slate-400);
}

.form-footer >>> .el-link {
  font-size: 14px;
  margin-left: 4px;
}

/* ===== Responsive ===== */
@media (max-width: 640px) {
  .nav-inner {
    padding: 0 16px;
  }

  .nav-name {
    font-size: 18px;
  }

  .nav-logo {
    width: 28px !important;
    height: 28px !important;
  }

  .pwd-section {
    align-items: flex-start;
    padding: 90px 16px 32px;
  }

  .pwd-card {
    padding: 28px 20px;
  }

  .pwd-title {
    font-size: 24px;
  }

  .btn-code {
    min-width: 104px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User2/Password.vue